<!--
 * @Date: 2022-08-04 11:34:05
 * @LastEditTime: 2022-08-15 21:40:44
 * @FilePath: /vue-medweb/packages/vue-m-comprehensive/src/components/Video/index.vue
 * @Description: 视频播放区域
-->
<template>
  <div class="video">
    <div class="player-wrap">
      <img v-if="!showVideo" class="live-cover" :src="playImage" alt="" />
      <img
        v-if="!showVideo"
        src="https://resource.chunyu.mobi/@/media/images/2022/08/12/8332/635c3a53b395_w138_h138_.png"
        class="play-btn"
        @click="playVideo"
      />
      <video
        v-show="showVideo"
        ref="video"
        x5-video-player-type="h5-page"
        :src="videoUrl"
        width="100%"
        webkit-playsinline="true"
        playsinline="true"
        controls
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Video',
  props: {
    playImage: {
      type: String,
      default: '',
    },
    videoUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showVideo: false,
    };
  },
  methods: {
    playVideo() {
      this.$emit('playVideo');
      this.showVideo = true;
      this.$refs.video.play();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.video {
  position: relative;
  width: rem(345);
  height: rem(230);
  margin: rem(-20) rem(15) rem(10);
  background: url('https://resource.chunyu.mobi/@/media/images/2022/08/04/3588/de3e15bc60e5_w2096_h1407_.png')
    no-repeat;
  background-size: 100%;
  .player-wrap {
    position: relative;
    top: rem(15);
    width: rem(315);
    height: rem(177);
    margin: auto;
    // background: linear-gradient(0deg, #f8c7d5, #9995ef);
    img.live-cover {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
    }
    img.play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      width: rem(46);
      height: rem(46);
      transform: translate(-50%, -50%);
    }
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    background: black;
  }
}
</style>
